import jwt_decode from 'jwt-decode';
import store from 'store';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { Buffer } from 'buffer';

export const pending = (type) => `${type}_PENDING`;
export const fulfilled = (type) => `${type}_FULFILLED`;
export const rejected = (type) => `${type}_REJECTED`;

export const decodeToken = () => {
  if (store.get('token')) {
    const token = store.get('token');
    return jwt_decode(token);
  }
};

/**
 * Mutates and appends array to form data
 * @param {FormData} formData
 * @param {Array} data
 * @param {String} fieldName
 * @returns {FormData}
 */
export const appendArrayToFormData = (formData, data, fieldName) => {
  if (!Array.isArray(data)) {
    throw new Error('Data must be array');
  }
  data.forEach((element, index) => {
    formData.append(`${fieldName}[${index}]`, element);
  });
  return formData;
};

export const removeNonDigit = (value) => {
  return value.replace(/\D/g, ''); // remove all non-digits
};

export const formatNumber = (number) => {
  return Number(removeNonDigit(number)).toLocaleString(); // format number
};

export const expireSession = () => {
  if (decodeToken() && decodeToken().exp * 1000 <= new Date().getTime()) {
    store.remove('token');
    window.location.href = '/';
  }
};

export const getStatusColor = (status) => {
  const s = status?.toLowerCase();
  if (s?.includes('pending') || s?.includes('progress')) return 'warning';
  if (s?.includes('approved')) return 'success';
  if (s?.includes('assigned')) return 'blue';
  if (s?.includes('rejected') || s?.includes('fail')) return 'error';
  else return;
};

export const logout = (refresh = true) => {
  store.clearAll();
  if (refresh) {
    window.location.href = '/auth';
  }
  return false;
};

export const getUserNames = () => {
  const { firstName, lastName } = decodeToken();
  return `${firstName} ${lastName}`;
};

export const getNidforUser = () => {
  const { nationalId } = decodeToken();
  return nationalId;
}

export const downloadFile = (data) => {
  try {
    const buffer = Buffer.from(data.fileBlob.data);
    const blob = new Blob([buffer], {
      type: `${data?.fileType};charset=utf-8`,
    });
    saveAs(blob, data.fileName);
  } catch (error) {
    console.log('Unable to download file', error);
  }
};

export const isUserAuthenticated = () => {
  const token = decodeToken();
  return token ? true : false;
};

export const inputRules = [
  {
    required: true,
    message: 'This field is required',
  },
];
export const personalEmailHandles = ['yahoo.com', 'gmail.com', 'hotmail.com'];

export const userFilters = [
  {
    id: 1,
    title: 'Applications',
    value: 'applied',
    filters: [
      {
        id: 11,
        value: true,
        name: 'Applicant',
      },
      {
        id: 11,
        value: false,
        name: 'Non-Applicant',
      },
    ],
  },
  // {
  //   id: 2,
  //   title: "Admin",
  //   value: "admin",
  //   filters: [
  //     {
  //       id: 21,
  //       value: true,
  //       name: "Admins",
  //     },
  //     {
  //       id: 21,
  //       value: false,
  //       name: "Non-Admins",
  //     },
  //   ],
  // },
];

export const genders = {
  Male: 'Male',
  Female: 'Female',
  Masculain: 'Male',
  Feminin: 'Female',
  Gabo: 'Male',
  Gore: 'Female',
};

export const applicantFilters = [
  {
    id: 1,
    title: 'RHA Status',
    value: 'backEndStatus',
    filters: [
      {
        id: 11,
        value: 'Approved',
        name: 'Approved',
      },
      {
        id: 12,
        value: 'Pending',
        name: 'Pending',
      },
      {
        id: 13,
        value: 'Under-Review',
        name: 'Under-Review',
      },
      {
        id: 14,
        value: 'Rejected',
        name: 'Rejected',
      },
      {
        id: 15,
        value: 'Auto-Rejected',
        name: 'Auto-Rejected',
      },
    ],
  },
  {
    id: 2,
    title: 'Bank Status',
    value: 'bankStatus',
    filters: [
      {
        id: 21,
        value: 'Disbursed',
        name: 'Disbursed',
      },
      {
        id: 22,
        value: 'Pending',
        name: 'Pending',
      },
      {
        id: 23,
        value: 'Under-Process',
        name: 'Under-Process',
      },
    ],
  },
  {
    id: 3,
    title: 'Level',
    value: 'level',
    filters: [
      {
        id: 31,
        value: 'backend-officer',
        name: 'Back-end Officer',
      },
      {
        id: 32,
        value: 'bank',
        name: 'Bank',
      },
    ],
  },
];

export const pfiFilter = [
  {
    id: 1,
    title: 'Bank Status',
    value: 'bankStatus',
    filters: [
      {
        id: 21,
        value: 'Pending',
        name: 'Pending',
      },
      {
        id: 22,
        value: 'Under-Process',
        name: 'Under-Process',
      },
      {
        id: 23,
        value: 'Disbursed',
        name: 'Disbursed',
      },
    ],
  },
];

export const exportFromJson = (data, fileName) => {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(wb, ws, 'exported_data');
  XLSX.writeFile(wb, `${fileName}.xlsx`);
};

export const userRoles = {
  RHA_OFFICER: 'RHA Officer'
}